import { Link } from 'react-router-dom';

/**
 * YARDIM — tek başlık, iki sekme. Fihrist ("ne nedir, nasıl hesaplanır") ile
 * Kullanım Kılavuzu ("ekran ekran, adım adım") aynı yardımın iki yüzüdür;
 * kullanıcı ikisini ayrı sistem olarak görmesin diye üstte hep bu şerit durur.
 */
export default function YardimSekmeleri({ aktif }: { aktif: 'fihrist' | 'kilavuz' }) {
  const sekme = (id: 'fihrist' | 'kilavuz', ad: string, alt: string) => (
    <Link to={`/${id}`} className={`ccd-rapor-hap${aktif === id ? ' ccd-is-active' : ''}`} aria-current={aktif === id ? 'page' : undefined} title={alt}>
      {ad}
    </Link>
  );
  return (
    <nav className="ccd-rapor-gezgin ccd-yazdirma-gizli" aria-label="Yardım">
      {sekme('fihrist', 'Fihrist', 'Her rakam ve kavram: ne nedir, nasıl hesaplanır')}
      {sekme('kilavuz', 'Kullanım kılavuzu', 'Ekran ekran, adım adım anlatım ve turlar')}
    </nav>
  );
}
